export class FetchError extends Error {
    public status: number;

    constructor(public response: Response) {
        super(`Call to ${response.url} failed with status ${response.status}`);

        this.status = response.status;
    }
}
